// Edit business contact details here — every page reads from this file.
export const BUSINESS = {
  name: "Assemble Pro",
  tagline: "You Buy It. We Assemble It. We Install It.",
  phoneDisplay: "(226) 266-7140",
  phoneHref: "tel:+12262667140",
  smsHref: "sms:+12262667140",
  email: "contact@AssemblePro.ca",
  emailHref: "mailto:contact@AssemblePro.ca",
  baseCity: "Woodstock, Ontario",
  hours: [
    ["Monday – Sunday", "9:00 AM – 7:00 PM"],
  ],
  ownerName: "[Owner name]",
  serviceTowns: [
    "Woodstock", "Ingersoll", "Tillsonburg", "Norwich", "Tavistock", "Embro",
    "Thamesford", "Innerkip", "Beachville", "Drumbo", "Plattsville", "Otterville",
  ],
};
